module.exports = __webpack_public_path__ + "static/media/drinks.814b4be7.svg";